module.exports = __webpack_public_path__ + "img/lb.e4cfe649.svg";